import { BYO_MARKETS_REQUEST, BYO_MARKETS_SUCCESS, BYO_MARKET_FETCHING_STARTED, BYO_MARKET_CATEGORIES_FILTER } from '../constants';
export const getMarkets = (locale, eventId, useBYOFreedom) => ({
    type: BYO_MARKETS_REQUEST,
    payload: {
        locale,
        eventId,
        useBYOFreedom,
    },
});
export const marketFetchingStarted = () => ({
    type: BYO_MARKET_FETCHING_STARTED,
});
export const saveMarkets = (markets) => ({
    type: BYO_MARKETS_SUCCESS,
    payload: markets,
});
export const filterMarkets = (categoryNameFilter) => ({
    type: BYO_MARKET_CATEGORIES_FILTER,
    categoryNameFilter,
});
